module.exports = __webpack_public_path__ + "static/blog-20-7ca39265088c705a0e486a364356f1f9.png";